import React from "react";
import {
  IonButton,
  IonButtons,
  IonSegment,
  IonSegmentButton,
  IonLabel,
} from "@ionic/react";
import styles from "./ChallengeCard.module.css";
import { States, usePersistedState } from "./usePersistedState";

interface ChallengeActionButtonProps {
  guid: string;
}

export const ChallengeActionButtons: React.FC<ChallengeActionButtonProps> = ({
  guid,
}) => {
  const [storedValue, setStoredValue] = usePersistedState(
    guid,
    States.Incomplete
  );

  const getChallengeStateColour = () => {
    if (storedValue === States.Complete) {
      return "success";
    } else if (storedValue === States.InProgress) {
      return "warning";
    } else if (storedValue === States.Incomplete) {
      return "secondary";
    }
  };

  return (
    <>
      {storedValue === States.Incomplete && (
        <IonButtons slot="end">
          <IonButton
            shape="round"
            color="primary"
            fill="solid"
            disabled={!guid}
            expand="full"
            onClick={() => setStoredValue(States.InProgress)}
          >
            <p className={styles.startButton}>Start</p>
          </IonButton>
        </IonButtons>
      )}
      {storedValue !== States.Incomplete && (
        <>
          <IonSegment
            onIonChange={() => setStoredValue(States.Complete)}
            value={States.InProgress}
            color={getChallengeStateColour()}
          >
            <IonSegmentButton value={States.InProgress} disabled>
              <IonLabel>In Progress</IonLabel>
            </IonSegmentButton>
            <IonSegmentButton value={States.Complete}>
              <IonLabel>Complete</IonLabel>
            </IonSegmentButton>
          </IonSegment>
        </>
      )}
    </>
  );
};
